<template>
  <b-form-group
    label="Para Birimi"
    label-for="id_currencies"
  >
    <validation-provider
      #default="{ errors }"
      name="Para Birimi"
      rules="required"
    >
      <v-select
        id="id_currencies"
        v-model="dataItem.id_currencies"
        :options="dataList"
        label="title"
        :reduce="item => item.id"
        placeholder="Seçiniz"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'Currencies',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['bankAccounts/dataItem']
    },
    dataList() {
      return this.$store.getters['currencies/dataList']
    },
  },
  created() {
    this.getDataList()
    localize('tr')
  },
  methods: {
    getDataList() {
      this.$store.dispatch('currencies/getDataList', {
        select: [
          'currencies.id AS id',
          'currencies.title AS title',
        ],
      })
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
